module.exports = __webpack_public_path__ + "static/media/IMG_3823.4aaa8eb2.JPG";